export default __webpack_public_path__ + "static/media/crisp-paper-ruffles.a006a9e2.png";